const currencyFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function parseMoney(value: string | number | null | undefined): number {
  if (value == null) return 0
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }
  const trimmed = value.trim()
  if (!trimmed) return 0
  const normalized = trimmed.replace(/[$,\s]/g, '')
  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : 0
}

export function formatFixedAssetMoney(value: string | number | null | undefined): string {
  if (value == null || (typeof value === 'string' && !value.trim())) {
    return '—'
  }
  const num = typeof value === 'number' ? value : parseMoney(value)
  if (!Number.isFinite(num)) return '—'
  return currencyFmt.format(num)
}

/** Format a money field for editing: always $#,##0.00, including $0.00. */
export function formatMoneyInput(value: string | number | null | undefined): string {
  return currencyFmt.format(parseMoney(value))
}

/** Format an ISO date (or datetime) as yyyy-mm-dd. */
export function formatIsoDate(value: string | null | undefined): string {
  if (!value) return '—'
  const dateOnly = value.slice(0, 10)
  return /^\d{4}-\d{2}-\d{2}$/.test(dateOnly) ? dateOnly : value
}
